import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, onUnmounted } from "vue";
import NotificationToast from "@/components/NotificationToast.vue";
import { toggleModal, toggleOffcanvas } from "@/utils/Helper";
import { pusherService } from "@/di/pusher";
import pkg from "../package.json";
import { startFirebase } from "./firebaseinit";
import { useOffcanvasStore } from "./store/useOffcanvasStore";
import { useChatRoomConfigStore } from "./store/useChatRoomConfigStore";
import { useAppointmentRatingPendingStore } from "./store/useAppointmentRatingPendingStore";
import AppointmentRating from "./views/Appointments/AppointmentRating/AppointmentRating.vue";
import ChatRoomModal from "./views/Chat/ChatRoom/ChatRoomModal.vue";
import Approaches from "./views/Modals/Approaches/Approaches.vue";
import Specialties from "./views/Modals/Specialties/Specialties.vue";
import SubscriptionModal from "./views/Modals/SubscriptionModal/SubscriptionModal.vue";
import OffcanvasViews from "./views/OffcanvasViews/OffcanvasViews.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

document.title = "Psiapp Pro | Web";

const offcanvasStore = useOffcanvasStore();
const chatRoomConfigStore = useChatRoomConfigStore();
const appointmentRatingPendingStore = useAppointmentRatingPendingStore();
const chatId = computed(() => chatRoomConfigStore.config?.id);
const chatMode = computed(() => chatRoomConfigStore.config?.mode);
const offcanvasPath = computed(() => offcanvasStore.config?.path);
const appointmentRatingPending = computed(
  () => appointmentRatingPendingStore.pending,
);

onMounted(() => {
  if (offcanvasPath.value) {
    toggleOffcanvas("offcanvas_views");
  }
  if (chatId.value && chatMode.value === "modal") {
    toggleModal("chat_room");
  }
  if (appointmentRatingPending.value) {
    toggleModal("appointment_rating_pending");
  }

  console.log("VERSION: ", `${pkg.version} ${process.env.VUE_APP_ENV_NAME}`);
  pusherService.connect();

  /**
   * NOTE: SPRINT 26
   * ITEM 1201
   * app criado na conta da phurshell, fiz igual o psi pacientes e so funciona em prod
   * os dados do FB estao como autoday... não me pergunte
   */
  startFirebase();
});

onUnmounted(() => {
  pusherService.disconnect();
});

return (_ctx: any,_cache: any) => {
  const _component_ConfirmationAlert = _resolveComponent("ConfirmationAlert")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationAlert),
    _createVNode(SubscriptionModal),
    _createVNode(NotificationToast),
    _createVNode(OffcanvasViews),
    _createVNode(ChatRoomModal),
    _createVNode(Specialties),
    _createVNode(Approaches),
    _createVNode(_component_router_view),
    _createVNode(AppointmentRating)
  ], 64))
}
}

})